// extracted by css-extract-rspack-plugin
export default {"radio":"radio-mQunhR","vcfc":"vcfc-S7qdBm"};